<template>
  <div class="mobile-menu__language">
    <span v-if="!isUkLanguage" class="mobile-menu__language-item">{{  $t('up.menu.lang_pl') }}</span>
    <a v-else
       :href="plHref"
       @click="changeLangAction($event, 'pl')"
       class="mobile-menu__language-link">
      {{  $t('up.menu.lang_pl') }}
    </a>
    <span v-if="isUkLanguage" class="mobile-menu__language-item">{{  $t('up.menu.lang_uk') }}</span>
    <a v-else
       :href="ukHref"
       @click="changeLangAction($event, 'uk')"
       class="mobile-menu__language-link">
      {{  $t('up.menu.lang_uk') }}
    </a>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'MobileMenuLanguage',
  methods: {
    changeLangAction (e, lang) {
      e.preventDefault()
      axios.get('/language/set/', {
        params: {
          l: lang
        }
      }).then(res => {
        if (res.data.result) {
          location.reload()
        }
      })
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix', 'isUkLanguage']),
    ukHref () {
      const currLocation = window.location.pathname
      return '/uk' + currLocation
    },
    plHref () {
      const currLocation = window.location.pathname
      return currLocation.replace('/uk/', '/')
    }
  }
}
</script>

<style lang="sass" scoped>
.mobile-menu__language
  display: flex
  align-items: center
  font-size: 15px
  line-height: 18px
  letter-spacing: 0.06em
  text-transform: uppercase
  background-color: #f5f5f5
  border-radius: 3px
  padding: 3px
  &-item
    color: #333333
    padding: 4px 9px
    border-radius: 3px
    background-color: #ffffff
  &-link
    color: #333333
    padding: 4px 9px
    border-radius: 3px
    text-decoration: none
</style>
